// assets/futurebuild-thankyou.js
// Futurebuild 2026 — Thank You Page Logic
// Reads ?Product_Interest__c= param forwarded by Pardot data forwarding
// Falls back to ?ref= param if Product_Interest__c is not present

document.addEventListener('DOMContentLoaded', function () {

  // ─────────────────────────────────────────────────────────────────
  // BROCHURE MAP
  // Keyed on Product Interest VALUES (what Pardot forwards)
  // These match the `value` field in futurebuild-landing.js PRODUCTS map
  // ─────────────────────────────────────────────────────────────────
  var BROCHURE_MAP = {
    'cavity sliders':           'https://cdn.shopify.com/s/files/1/0106/3741/0361/files/Cavity_Sliders_Brochure.pdf',
    'barwon doors':             'https://cdn.shopify.com/s/files/1/0106/3741/0361/files/Barwon_Brochure_2026_30-01.pdf?v=1769743882',
    'silencio aurora 70':       'https://cdn.shopify.com/s/files/1/0106/3741/0361/files/Silencio_Aurora_70_Double_Glazed_Hinged_Doors_2026_05-05.pdf?v=1778117501',
    'silencio timber doors':    'https://cdn.shopify.com/s/files/1/0106/3741/0361/files/Acoustic_Timber_Doors_Brochure_2026_07-05.pdf?v=1778134667',
    'platinum 90':              'https://cdn.shopify.com/s/files/1/0106/3741/0361/files/Platinum_Suite_Brochure_JULY_2025-compressed.pdf?v=1753684852',
    'definium 145':             'https://cdn.shopify.com/s/files/1/0106/3741/0361/files/145_Partition_Suite_2026_FEB_4.pdf?v=1770175624',
    'definium 90 dgu':          'https://cdn.shopify.com/s/files/1/0106/3741/0361/files/Definium_Suite_Brochure_2025_30-07.pdf?v=1754267437',
    'platinum 90 integrated':   'https://cdn.shopify.com/s/files/1/0106/3741/0361/files/Platinum_Suite_Brochure_JULY_2025-compressed.pdf?v=1753684852',
    'silencio overtaking':      'https://cdn.shopify.com/s/files/1/0106/3741/0361/files/Silencio_Amazon_Overtaking_system_14-11D.pdf?v=1763097616',
    'statera anti slam':        'https://cdn.shopify.com/s/files/1/0106/3741/0361/files/Statera_Anti_Slam_System_flyer_-_21-11-compressed_1.pdf?v=1763681564',
    'future build sydney':       'https://cdn.shopify.com/s/files/1/0106/3741/0361/files/NSW_Future_Builde_Event_Brochure_2026_FINAL_D-compressed.pdf?v=1780979825'
  };

  // Display names for button label
  var PRODUCT_NAMES = {
    'cavity sliders':           'Cavity Sliding Systems',
    'barwon doors':             'Barwon Aluminium Doors',
    'silencio aurora 70':       'Silencio Aurora 70',
    'silencio timber doors':    'Silencio Timber Doors',
    'platinum 90':              'Platinum 90 Partition',
    'definium 145':             'Definium 145 Partition',
    'definium 90 dgu':          'Definium 90 Double Glazed Unit',
    'platinum 90 integrated':   'Platinum 90 Integrated Sliding System',
    'silencio overtaking':      'Silencio Amazon Overtaking',
    'statera anti slam':        'Statera Anti Slam System',
    'future build sydney':        'Future Build Sydney'
  };

  // Ref param fallback map (keyed on ?ref= value)
  var REF_TO_PRODUCT = {
    'cavity-sliders':           'cavity sliders',
    'barwon-doors':             'barwon doors',
    'silencio-aurora-70':       'silencio aurora 70',
    'silencio-timber-doors':    'silencio timber doors',
    'platinum-90':              'platinum 90',
    'definium-145':             'definium 145',
    'definium-90-dgu':          'definium 90 dgu',
    'platinum-90-integrated':   'platinum 90 integrated',
    'silencio-overtaking':      'silencio overtaking',
    'statera-anti-slam':        'statera anti slam',
    'futurebuild-sydney':        'future build sydney'
  };

  // ─────────────────────────────────────────────────────────────────
  // RESOLVE PRODUCT KEY
  // Priority 1: Product_Interest__c param (forwarded by Pardot)
  // Priority 2: ref param (direct URL or fallback)
  // ─────────────────────────────────────────────────────────────────
  var params = new URLSearchParams(window.location.search);

  // Pardot forwards Product_Interest__c as a URL param
  var productInterest = (params.get('Product_Interest__c') || '').toLowerCase().trim();

  // Fallback to ref param
  var ref = (params.get('ref') || sessionStorage.getItem('fb_ref') || '').toLowerCase().trim();

  var refProduct = REF_TO_PRODUCT[ref] || '';

  // Use whichever we have — Product_Interest__c takes priority
  var productKey = productInterest || refProduct;

  var url  = BROCHURE_MAP[productKey];
  var name = PRODUCT_NAMES[productKey];

  var link     = document.getElementById('brochure-link');
  var btnLabel = document.getElementById('brochure-btn-label');
  var wrapper  = document.getElementById('brochure-download-wrapper');
  var fallback = document.getElementById('brochure-fallback');
  var subtitle = document.getElementById('success-subtitle');

  if (url && link) {
    link.href = url;
    if (btnLabel) btnLabel.textContent = 'Download ' + name + ' Brochure';
    if (subtitle) subtitle.textContent = 'Your ' + name + ' brochure is on its way.';

    // Auto-trigger download after 1.5s
    setTimeout(function () {
      window.location.href = url;
    }, 1500);

    link.addEventListener('click', function () {
      trackEvent('brochure_download', { product: name });
    });

  } else {
    if (wrapper)  wrapper.style.display  = 'none';
    if (fallback) fallback.style.display = 'block';
    if (subtitle) subtitle.textContent   = 'Thanks for connecting with us at Futurebuild 2026';
  }

  // ─────────────────────────────────────────────────────────────────
  // ANALYTICS HELPER
  // ─────────────────────────────────────────────────────────────────
  function trackEvent(name, props) {
    if (typeof gtag !== 'undefined') {
      gtag('event', name, props);
    }
  }

  // Track CTA button clicks
  document.querySelectorAll('.btn').forEach(function (button) {
    button.addEventListener('click', function () {
      trackEvent('cta_click', {
        event_category: 'Futurebuild Thank You Page',
        event_label: this.textContent.trim()
      });
    });
  });

  // ─────────────────────────────────────────────────────────────────
  // SCROLL ANIMATIONS
  // ─────────────────────────────────────────────────────────────────
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  document.querySelectorAll('.badge').forEach(function (el, i) {
    el.style.opacity    = '0';
    el.style.transform  = 'translateY(20px)';
    el.style.transition = 'all 0.5s ease ' + (i * 0.1) + 's';
    observer.observe(el);
  });

  var animateStyle = document.createElement('style');
  animateStyle.textContent = '.animate-in { opacity: 1 !important; transform: translateY(0) !important; }';
  document.head.appendChild(animateStyle);

  // ─────────────────────────────────────────────────────────────────
  // BUTTON RIPPLE EFFECT
  // ─────────────────────────────────────────────────────────────────
  var rippleStyle = document.createElement('style');
  rippleStyle.textContent = '@keyframes rippleEffect { to { transform: scale(4); opacity: 0; } }';
  document.head.appendChild(rippleStyle);

  document.querySelectorAll('.btn').forEach(function (button) {
    button.addEventListener('mouseenter', function (e) {
      var ripple = document.createElement('span');
      var rect   = this.getBoundingClientRect();
      var size   = Math.max(rect.width, rect.height);
      var x      = e.clientX - rect.left - size / 2;
      var y      = e.clientY - rect.top - size / 2;

      ripple.style.cssText = [
        'position:absolute',
        'background:rgba(255,255,255,0.25)',
        'border-radius:50%',
        'transform:scale(0)',
        'animation:rippleEffect 0.6s ease-out',
        'pointer-events:none',
        'width:' + size + 'px',
        'height:' + size + 'px',
        'left:' + x + 'px',
        'top:' + y + 'px'
      ].join(';');

      this.style.position = 'relative';
      this.style.overflow = 'hidden';
      this.appendChild(ripple);
      setTimeout(function () { ripple.remove(); }, 600);
    });
  });

});